(() => {
  if (window.SpiritStockAwareFilters) return;

  const optionPrefix = 'filter.v.option.';
  let applyTimer;

  const normalise = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  const getActiveOptionFilters = () => {
    const filters = new Map();
    const params = new URLSearchParams(window.location.search);

    params.forEach((value, key) => {
      if (!key.startsWith(optionPrefix)) return;
      const option = normalise(key.slice(optionPrefix.length));
      if (!filters.has(option)) filters.set(option, new Set());
      filters.get(option).add(normalise(value));
    });

    return filters;
  };

  const parseVariantData = (card) => {
    if (card.stockAwareVariantData) return card.stockAwareVariantData;
    const dataNode = card.querySelector('[data-stock-aware-variants]');
    if (!dataNode) return null;

    try {
      const payload = JSON.parse(dataNode.textContent);
      card.stockAwareVariantData = {
        options: payload.options.map(normalise),
        variants: payload.variants.map((variant) => variant.map(normalise)),
      };
      return card.stockAwareVariantData;
    } catch (error) {
      console.warn('Unable to read stock-aware variant data.', error);
      return null;
    }
  };

  const variantMatches = (variant, options, filters) => {
    for (const [filterOption, acceptedValues] of filters) {
      const optionIndex = options.indexOf(filterOption);
      if (optionIndex === -1 || !acceptedValues.has(variant[optionIndex])) return false;
    }
    return true;
  };

  const apply = () => {
    const filters = getActiveOptionFilters();
    const cards = document.querySelectorAll('product-block[data-stock-aware-product]');

    cards.forEach((card) => {
      const data = parseVariantData(card);
      const shouldShow = filters.size === 0
        || !data
        || data.variants.some((variant) => variantMatches(variant, data.options, filters));

      card.classList.toggle('stock-filter-hidden', !shouldShow);
      card.toggleAttribute('aria-hidden', !shouldShow);
    });

    window.dispatchEvent(new CustomEvent('spirit:stock-filter-applied', {
      detail: {
        activeOptionFilters: filters.size,
        visibleCards: document.querySelectorAll('product-block[data-stock-aware-product]:not(.stock-filter-hidden)').length,
      },
    }));
  };

  const scheduleApply = () => {
    window.clearTimeout(applyTimer);
    applyTimer = window.setTimeout(apply, 20);
  };

  const start = () => {
    apply();
    const collectionSection = document.querySelector('filter-container')?.closest('[data-section-id]');
    if (collectionSection) {
      new MutationObserver(scheduleApply).observe(collectionSection, {
        childList: true,
        subtree: true,
      });
    }
    window.addEventListener('popstate', scheduleApply);
  };

  window.SpiritStockAwareFilters = { apply: scheduleApply };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
